import { useGlobalContext } from "./context/globalContext";
import React, { useState, useRef, useEffect } from "react";
import {
  FaSchool,
  FaFilm,
  FaShoppingCart,
  FaUtensils,
  FaHospitalSymbol,
} from "react-icons/fa";

const LocationBenefits2 = () => {
  const { handleShowModal } = useGlobalContext();
  const [activeDetail, setActiveDetail] = useState(null);
  const detailsRef = useRef(null);

  // Handle click outside to close details
  useEffect(() => {
    const handleClickOutside = (event) => {
      // Check if click is outside both the details and the icon
      if (
        detailsRef.current &&
        !detailsRef.current.contains(event.target) &&
        !event.target.closest(".benefit-icon")
      ) {
        setActiveDetail(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Handle icon click
  const handleIconClick = (index, event) => {
    event.stopPropagation();
    setActiveDetail(activeDetail === index ? null : index);
  };
  const benefits = [
    {
      icon: <FaSchool />,
      title: "Education",
      details: [
        "Euro School* – 1 Min",
        "Billabong High School – 2 Mins",
        "Lodha World School – 6 Mins",
        "Orchids The Int'l School – 8 Mins",
        "Podar Int'l School – 11 Mins",
      ],
    },
    {
      icon: <FaHospitalSymbol />,
      title: "Hospitals",
      details: [
        "Jupiter Hospital – 10 Mins",
        "Hiranandani Hospital – 11 Mins",
        "Kaushalya Hospital – 14 Mins",
        "Life Line Hospital – 16 Mins",
      ],
    },
    {
      icon: <FaUtensils />,
      title: "Restaurants",
      details: [
        "Barbeque Nation – 10 Mins",
        "Global Fusion – 11 Mins",
        "Mainland China – 11 Mins",
        "Urban Tadka – 11 Mins",
        "Fusion Dhaba – 12 Mins",
      ],
    },
    {
      icon: <FaShoppingCart />,
      title: "Malls",
      details: [
        "Lake City Mall – 2 Mins",
        "Viviana Mall – 6 Mins",
        "Korum Mall – 6 Mins",
        "R Mall – 7 Mins",
        "Hypercity – 8 Mins",
        "The Walk – 9 Mins",
      ],
    },
    {
      icon: <FaFilm />,
      title: "Multiplexes",
      details: [
        "Cinemax – 2 Mins",
        "Cinepolis – 6 Mins",
        "Inox – 6 Mins",
        "Gold Cinema – 6 Mins",
        "R Adlabs, Kalyan – 9 Mins",
      ],
    },
  ];
  return (
    <>
      <div className="section shadow-sm lazyloaded">
        <div className="lb-container">
          <div className="lb-map">
            <img src="/images/lb.PNG" alt="Location Overview" />
          </div>
          <div className="lb-content">
            <div className="lb-content-body">
              <h2 className="head text-capitalize text-center">
                Dosti Nest - Location & Connectivity
              </h2>
              <div className="cards">
                {benefits.map((benefit, index) => (
                  <div
                    key={index}
                    className={`crd position-${index + 1}  ${
                      activeDetail === index ? "alive-card" : ""
                    } `}
                  >
                    <div
                      className="crd-icon"
                      onClick={(e) => handleIconClick(index, e)}
                    >
                      {benefit.icon}
                      <span className="crd-title">{benefit.title}</span>
                    </div>
                    <div
                      ref={activeDetail === index ? detailsRef : null}
                      className={`crd-details ${
                        activeDetail === index ? "active" : ""
                      }`}
                      id="card-details-scroll"
                    >
                      <ul>
                        {/* {benefit.details.map((detail, idx) => (
                          <li key={idx}>{detail}</li>
                        ))} */}
                        {benefit.details.map((detail, idx) => {
                          const parts = detail.split(" – "); // Using " – " (en dash) for separation
                          if (parts.length === 2) {
                            return (
                              <li key={idx}>
                                <span>{parts[0]}</span>
                                <span>{parts[1]}</span>
                              </li>
                            );
                          } else {
                            return <li key={idx}>{detail}</li>; // Handle cases with no " – "
                          }
                        })}
                      </ul>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="lb-content-footer">
              <span className="new-button " onClick={handleShowModal}>
                <span className="new-button-inner">
                  <span className="underline-animation">Get All Details</span>
                </span>
              </span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default LocationBenefits2;
